import React, { useState, useEffect } from "react";
import NeoIconBlack from "../../../Images/svg/Neoo_icon_black.svg";
import { useSelector } from "react-redux";
import neoologov2 from "../../../Images/neoologov2.svg";

const NeoCardLink = ({ data }) => {
    const { UserProfileID } = useSelector((state) => state.app);
    const [link, setLink] = useState("/");
    useEffect(() => {
        let businessPageLink = '/';
        if (UserProfileID?.businessStatus && UserProfileID?.companyName && UserProfileID?.status == "Active") {
            const slug = data?.companySlug || data?.companyName?.toLowerCase().replace(/\s+/g, "_");
            businessPageLink = process.env.REACT_APP_APPLICATION_URL + '/businesspage/' + slug;
        }
        if (UserProfileID?.neooBusinessPageLink) {
            businessPageLink = UserProfileID?.neooBusinessPageLink;
        }
        setLink(businessPageLink);
    }, [UserProfileID])
    return (
        <>
            <a
                href={`${link}`}
                target="_blank"
                className="bgsocial"
            >
                <img src={neoologov2} alt="Neoo business link" title="Neoo Business Page Link" style={{width:"80%"}}/>
            </a>
        </>
    );
}
export default NeoCardLink;